module.exports = __webpack_public_path__ + "static/media/ai-agents.69d29c6c.png";